var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFikseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.5 71.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.44,
    y: 2.6,
    width: 7.1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.22,
    y: 21.9,
    width: 6.2,
    height: 48.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.45,21.9h-8l-18.7,17.8c-1.6,1.5-3.3,3-4.8,4.5V0h-6.2v70h6.2v-18.6l5.4-5,21.1,23.6h8.6l-25.3-27.7,21.7-20.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.45,43.3l-7.6-1.5c-5.6-1.1-9.8-3-9.8-7.9s4.5-8.3,11.3-8.3c7.4,0,12.1,3.8,12.8,9.8h6.2c-.8-9.3-7.6-14.9-18.7-14.9-10.5,0-17.9,5.9-17.9,13.7,0,7.1,5.5,11.4,14.4,13.1l7.1,1.4c6.3,1.2,10.1,3.4,10.1,8.3,0,5.7-4.9,9.3-12.8,9.3-8.7,0-13.8-4.6-14.2-11.6h-6.1c.5,10,7.9,16.7,20.3,16.7,11.7,0,19-6.4,19-14.9,0-7.5-5.5-11.6-14.1-13.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.5,45.5c0-15.1-7.7-25-21.4-25-12.7,0-22.4,10.6-22.4,25.2,0,16.5,9.2,25.7,22.8,25.7,12.6,0,19.4-7.2,20.7-16h-6.2c-1.2,7.5-7,10.9-14.4,10.9-9.8,0-16.5-6.9-16.7-19.4h37.6v-1.4ZM161.2,42.1c.7-9.4,6.9-16.5,15.9-16.5s14.6,6.7,14.8,16.5h-30.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.36,5.7V0H3.21s-3.21,0-3.21,0v69.66c9.29,0,13.9-2.42,17.37-6.51,3.01-3.54,4.66-8.27,4.66-13.3,0-5.34-1.58-9.85-5.67-13.27h26.3v-5.7H6.6V5.7h37.76ZM6.6,62.69v-25.66c6.53,1.59,9.32,7.39,9.32,12.81s-3.04,11.46-9.32,12.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFikseLogo);
export default __webpack_public_path__ + "static/media/fikse-logo.412bcfed502c82d22c0b4a0ba97c7bdd.svg";
export { ForwardRef as ReactComponent };